'use strict';

if (typeof weblayers == "undefined") {var weblayers = {}};

function registerWeblayer(target = 'screen', name = 'NaN', code) {

	if (weblayers[target] != null)
	{
		console.warn("[weblayers] can't display layer '" + name + "', target '" + target + "' already taken by '" + weblayers[target] + "'");

		window.dataLayer.push({
			'event': 'registerWeblayer',
			'weblayer_target': target,
			'weblayer_name': name,
			'weblayer_result': false
		});

		return null;
	}

	weblayers[target] = name;
	
	window.dataLayer.push({
		'event': 'registerWeblayer',
		'weblayer_target': target,
		'weblayer_name': name,
		'weblayer_result': true
	});

	console.debug("[weblayers] display layer '" + name + "', target '" + target + "'");

	try {
		code();
	} catch (e) {
		console.error("[weblayers] error " + e);
		return null;
	}
	return 1;
}